import { BasicTooltip, ProfileImage, UserActivityImage, UserActivityProfileImage } from "thrive-components";
import { AcknowledgementType, UserActivity } from "@/interfaces/activityFeed";


export interface IActivityProfileData {
    imageUrl?: string,
    userActivity: UserActivity | AcknowledgementType, 
    timeStamp: string,
    dateStamp: string,
    isPopOut?: boolean
    secondUserImageUrl?: string,
    showSecondUser?: boolean
}

const ActivityProfileData = ({imageUrl, userActivity, timeStamp, dateStamp, isPopOut, secondUserImageUrl, showSecondUser}: IActivityProfileData) => {
    
    return (
        isPopOut 
            ?   <UserActivityProfileImage 
                    profileImageUrl={imageUrl} 
                    userActivity={userActivity} 
                    secondProfileImageUrl={showSecondUser ? secondUserImageUrl : undefined}
                    defaultSecondProfileImage={showSecondUser && !secondUserImageUrl}
                />
            
            :   <>  
                    <div className="left-panel">
                        <UserActivityImage activity={userActivity} />
                        
                        <BasicTooltip className={`activity-item-timestamp-tooltip above`} text={`${timeStamp} · ${dateStamp}`}>
                            <span className="time-stamp">{timeStamp}</span>
                        </BasicTooltip>
                    </div>
                    
                    <ProfileImage 
                        profileImageUrl={imageUrl} 
                        secondProfileImageUrl={showSecondUser ? secondUserImageUrl : undefined}   
                        defaultSecondProfileImage={showSecondUser && !secondUserImageUrl} 
                    />
                </>
        
    );
};
export default ActivityProfileData